import { withRouter } from 'react-router-dom'

import { compose, createSink } from 'recompose'

import { DISABLE_EXPERIMENTS } from 'app-constants'
import { withEnv } from 'utils/environment'
import { FlowRoute } from 'utils/FlowProvider/types'
import { withOptimizely } from 'utils/Optimizely'
import removeDuplicateQueryParams from 'utils/sourceAttributes'

const experimentsMap = new Map<string, any>([
  [
    FlowRoute.Welcome,
    [
      'growth-1307_remove_hero',
      'growth-1661_create_account',
      'growth-1661_bank_interstitial',
      'growth-1661_bank_linking',
      'growth-1661_personal_info',
    ],
  ],
])

const enhance = compose(withOptimizely, withEnv)

export const activate = ({ location, activateOptimizely, env }) => {
  const params = removeDuplicateQueryParams(location.search)

  // Allow opt out of all experiments for QA automation
  if (['dev', 'staging'].includes(env.mode) && params.disableExperiments) {
    window.sessionStorage.setItem(
      DISABLE_EXPERIMENTS,
      (params.disableExperiments === 'true').toString(),
    )
  }

  const key = location.pathname
  if (experimentsMap.get(key)) {
    return experimentsMap.get(key).forEach(experiment => {
      activateOptimizely(experiment)
    })
  } else {
    return null
  }
}

export default withRouter(enhance(createSink(activate)))
